import { unset } from "lodash"

const setPlaceholder = (select) => {
  if (select.value) select.classList.remove('--placeholder')
  if (!select.value) select.classList.add('--placeholder')
}

const onChangeSelect = () => {
  const selects = document.querySelectorAll('select')

  selects.forEach((select) => {
    setPlaceholder(select)

    select.addEventListener('change', (e) => {
      setPlaceholder(e.currentTarget)
    })
  })

}
export default onChangeSelect
